import template from './modal-dialog.html'
import css from './modal-dialog.css'
import { ModalDialogController } from './modal-dialog.controller.js'

export const ModalDialogComponent = {
  template: template,
  controller: ModalDialogController,
  controllerAs: 'ModalDialogController',
  transclude: true,         // contenu inséré (cf template)
  bindings: {
    title: '@',
    width: '@',
    height: '@',
    visible: '=',
    content: '='          // objet représentant le message et son contexte : relayé par SimulatorController
  },
  require: {
    parentSimulator: '^^simulatorComponent'
  }
}



// WEBPACK FOOTER //
// ./src/client/common/uiComponents/ModalDialog/modal-dialog.component.js